import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';
import { useGlobalContext, useQuizContext } from 'contexts';
import React from 'react';
import { getCssStylesFromQuizSettings } from 'utils/style-utils';

interface QuizSessionSplashScreenProps {
    onStartQuiz: () => void;
}

export const QuizSessionSplashScreen: React.FC<QuizSessionSplashScreenProps> = ({ onStartQuiz }) => {
    const { quiz } = useQuizContext();
    const gContext = useGlobalContext();
    const styles = getCssStylesFromQuizSettings(quiz.styles);

    return (
        <div style={styles.customTitlePageStyles} className="quiz-title-page-wrapper full-height">
            <Stack direction="column" spacing={2} alignItems="center">
                <h2 className="quiz-title" style={styles.slideCustomFontStyles}>
                    {quiz.name}
                </h2>
                <div style={styles.customTitleStyles}>
                    <p className="quiz-description" dangerouslySetInnerHTML={{ __html: quiz.description }}></p>
                    <p className="quiz-genre">{quiz.genreId && <>Genre: {gContext.getGenreName(quiz.genreId)}</>}</p>
                </div>
                <Button variant="contained" onClick={onStartQuiz}>
                    Start Quiz
                </Button>
            </Stack>
        </div>
    );
};
